import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { WhatsAppFloat } from './WhatsAppFloat';
import { AnnouncementBar } from './AnnouncementBar';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchAnnouncements } from '../lib/api';

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const [announcements, setAnnouncements] = useState([]);
  useEffect(() => { window.scrollTo({ top: 0 }); }, [pathname]);
  useEffect(() => { fetchAnnouncements().then(d => setAnnouncements(Array.isArray(d) ? d : [])).catch(() => {}); }, []);
  const hasBar = announcements.length > 0;
  return (
    <div className="bg-white text-[#0a0a0a] min-h-screen">
      {hasBar && <AnnouncementBar items={announcements} />}
      <Navbar topOffset={hasBar ? 36 : 0} />
      <main>{children}</main>
      <Footer />
      <ScrollToTop />
      <WhatsAppFloat />
    </div>
  );
};
